import axios from "axios";
import { useState } from "react";
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
import { useContext } from "react";
import AuthContext from "../Context/AuthContext";
import { API_URL } from "../Constant";

const baseURL = API_URL;

const useAxios = () => {
  const { authTokens, setUser, setAuthTokens, logoutUser } =
    useContext(AuthContext);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const axiosInstance = axios.create({
    baseURL,
    headers: { Authorization: `Bearer ${authTokens?.access}` },
  });

  axiosInstance.interceptors.request.use(async (req) => {
    const user = jwt_decode(authTokens.access);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    if (!isExpired) return req;
    if (isRefreshing) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return req;
    }
    setIsRefreshing(true);
    try {
      const response = await axios.post(`${baseURL}token/refresh/`, {
        refresh: authTokens.refresh,
      });

      localStorage.setItem("authTokens", JSON.stringify(response.data));

      setAuthTokens(response.data);
      setUser(jwt_decode(response.data.access));

      req.headers.Authorization = `Bearer ${response.data.access}`;
      return req;
    } catch (error) {
      console.error("Token refresh failed", error);
      logoutUser();
      throw error;
    } finally {
      setIsRefreshing(false);
    }
  });

  return axiosInstance;
};

export default useAxios;
